module.exports = __webpack_public_path__ + "static/img/3.93dada3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/pharmacy/1/3.png
// module id = FQIO
// module chunks = 1